module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offers/offers.component.css
// module id = ./src/app/offers/offers.component.css
// module chunks = main